<template>
    <svg width="72" height="60" viewBox="0 0 72 60" xmlns="http://www.w3.org/2000/svg">
        <path d="M36.009 11.718c.249-.564.468-1.137.75-1.683A17.775 17.775 0 0 1 50.136.333a18.801 18.801 0 0 1 15.138 3.582 16.371 16.371 0 0 1 6.453 10.272c.33 1.856.364 3.753.099 5.619a30.651 30.651 0 0 1-6.138 14.244 58.746 58.746 0 0 1-7.287 8.256c-2.259 2.124-4.59 4.2-6.96 6.207-3.3 2.805-6.915 5.241-10.413 7.818-1.659 1.221-3.327 2.433-5.019 3.669l-2.217-1.611c-2.727-1.992-5.448-3.993-8.181-5.976a106.824 106.824 0 0 1-12.39-10.476 58.458 58.458 0 0 1-8.673-10.518 29.355 29.355 0 0 1-4.17-10.224 17.352 17.352 0 0 1 .831-10.2 17.574 17.574 0 0 1 10.56-9.825 19.644 19.644 0 0 1 18.324 2.682 16.782 16.782 0 0 1 5.835 7.818c.021.018.051.027.081.048z" fill="#F796A1" fill-rule="nonzero"/>
    </svg>
</template>

<script>
export default {
    name: 'IconFavoriteBig',
};
</script>
